'use client';

import { ApiKeys, fetcher } from '@insta-club/api';
import { Container, LoadingLayer } from '@insta-club/components';
import { TermItem, TermsResponse } from '@insta-club/models';
import { BackHeader } from '@insta-club/ui';
import useSWR from 'swr';

function PrivacyPolicy() {
    const { data, isLoading } = useSWR<TermsResponse>(ApiKeys.GET_TERMS, (url: string) => fetcher(url, 'web', 'GET'));

    if (isLoading) return <LoadingLayer show={true} />;

    return (
        <>
            <BackHeader title='شرایط و قوانین استفاده' />
            <Container hasHeader>
                <div className='space-y-6'>
                    {data?.data?.map((item: TermItem) => {
                        return (
                            <div className='space-y-2.5' key={item.id}>
                                <h5 className='text-sm font-semibold text-gray-800'>{item.title}</h5>
                                <p
                                    className='text-sm font-medium text-gray-500'
                                    dangerouslySetInnerHTML={{ __html: item.text }}
                                ></p>
                            </div>
                        );
                    })}
                </div>
            </Container>
        </>
    );
}

export default PrivacyPolicy;

